import { render, staticRenderFns } from "./SelectedCompanies.vue?vue&type=template&id=50eb179c&"
import script from "./SelectedCompanies.vue?vue&type=script&lang=ts&"
export * from "./SelectedCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports